import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	widgetSettingsTitle: {
		id: 'servicedesk-widget-settings.header.widget-settings-title',
		defaultMessage: 'Widget',
		description: 'Title for the widget settings page, displayed in the header',
	},
	widgetSettingsDescriptionV2: {
		id: 'servicedesk-widget-settings.header.widget-settings-description-v-2',
		defaultMessage: `Allow customers to get help on your website through a widget. Give them access to knowledge base {br}
        articles and request forms, or let your virtual service agent answer questions and triage requests. <a>Read more {br} about the widget.</a>`,
		description:
			'Description for the widget settings page, displayed in the header. Describe what the widget is for and what the user needs to do to enable it.',
	},
	widgetSettingsDescription: {
		id: 'servicedesk-widget-settings.header.widget-settings-description',
		defaultMessage: `Allow customers to get help on your website through a widget. Give them access to knowledge base {br}
        articles and request forms, or let your virtual agent answer questions and triage requests. <a>Read more {br} about the widget.</a>`,
		description:
			'Description for the widget settings page, displayed in the header. Describe what the widget is for and what the user needs to do to enable it.',
	},
});
